<template>
  <div>
    <v-alert type="error"
      v-if="err"
      name="error"
      v-bind:err="err"
      v-bind:vm="vm"
      v-bind:info="info"
    >{{ err }}</v-alert>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: "error-boundary",
  props: {
    stopPropagation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      err: false,
      vm: null,
      info: null
    };
  },
  errorCaptured(err, vm, info) {
    console.log('--ERRor--')
    this.err = err;
    this.vm = vm;
    this.info = info;
    return !this.stopPropagation;
  }
};
</script>

<style scoped>

</style>
